import { BikeSpec } from './types';

/** KTM 150 EXC TPI (2024). KTM spec sheet: 143.99 cc 2T fuel injected, 6 speed, about 99 kg without fuel. */
export const KTM150EXCTPI: BikeSpec = {
  id: 'ktm150exctpi', brand: 'KTM', name: '150 EXC TPI', year: 2024, kind: 'enduro', stroke: '2T', displacement: 144,
  dryMass: 99, peakPower: 24, peakPowerRpm: 10500, peakTorque: 22, peakTorqueRpm: 9000, limiterRpm: 11500, idleRpm: 1700,
  torqueCurve: [[1700, 0.35], [4000, 0.5], [6500, 0.75], [9000, 1], [10500, 0.95], [11500, 0.8]],
  primary: 73 / 23, gearbox: [33 / 13, 30 / 15, 28 / 18, 26 / 20, 25 / 23, 23 / 25], finalDrive: 50 / 13,
  travelFront: 300, travelRear: 310, seatHeight: 960, wheelbase: 1487,
  level: 'beginner', discipline: 'enduro', livery: 'factory',
  model: { file: 'fleet/ktm150exctpi.glb', base: 'generic 2-stroke enduro in KTM colours', approximate: true },
  audio: { set: '2t', pitch: 1.1 },
  estimated: ['dryMass', 'peakPower', 'peakTorque', 'limiterRpm', 'torqueCurve', 'gearbox'],
};
